import { Any, JsonObject, JsonProperty } from 'json2typescript';
import {
  IntConverter,
  BooleanConverter,
  NullableString,
} from 'src/app/core/models/essentials';

@JsonObject('ResturantNameLangResponseModel')
export class ResturantNameLangModel {
  @JsonProperty('Lang', NullableString, true)
  Lang: string = undefined;
  @JsonProperty('Value', NullableString, true)
  Value: string = undefined;
}

@JsonObject('ResturantDescriptionLangResponseModel')
export class ResturantDescriptionLangModel {
  @JsonProperty('Lang', NullableString, true)
  Lang: string = undefined;
  @JsonProperty('Value', NullableString, true)
  Value: string = undefined;
}

@JsonObject('ResturantOverviewLangResponseModel')
export class ResturantOverviewLangModel {
  @JsonProperty('Lang', NullableString, true)
  Lang: string = undefined;
  @JsonProperty('Value', NullableString, true)
  Value: string = undefined;
}
@JsonObject('AdditionalInformationResponseModel')
export class AdditionalInformationModel {
  @JsonProperty('Lang', NullableString, true)
  Lang: string = undefined;
  @JsonProperty('Value', NullableString, true)
  Value: string = undefined;
}

@JsonObject('TimeSlot')
export class TimeSlot {
  @JsonProperty('From', NullableString, true)
  From: string = undefined;
  @JsonProperty('To', NullableString, true)
  To: string = undefined;
}

@JsonObject('ResturantAvailability')
export class ResturantAvailability {
  @JsonProperty('Day', NullableString, true)
  Day: string = undefined;
  @JsonProperty('IsOpen', BooleanConverter, true)
  IsOpen: boolean = undefined;
  @JsonProperty('isCustomSchedule', BooleanConverter, true)
  isCustomSchedule: boolean = undefined;
  @JsonProperty('TimeSlots', [TimeSlot], true)
  TimeSlots: TimeSlot[] = undefined;
}
@JsonObject('ResturantResponse')
export class ResturantResponse {
  @JsonProperty('_id', NullableString, true)
  _id: string = undefined;

  @JsonProperty('ResturantTypeData', [Object], true)
  ResturantTypeData: Object[] = undefined;

  @JsonProperty('ResturantType', Any, true)
  ResturantType: Any = undefined;

  @JsonProperty('Category', Any, true)
  Category: Any = undefined;

  @JsonProperty('ResturantNameLangs', [ResturantNameLangModel], true)
  ResturantNameLangs: [ResturantNameLangModel] = undefined;

  @JsonProperty(
    'ResturantDescriptionLangs',
    [ResturantDescriptionLangModel],
    true
  )
  ResturantDescriptionLangs: [ResturantDescriptionLangModel] = undefined;

  @JsonProperty('ResturantOverview', [ResturantOverviewLangModel], true)
  ResturantOverview: [ResturantOverviewLangModel] = undefined;

  @JsonProperty('ShowOnHomepage', BooleanConverter, true)
  ShowOnHomepage: boolean = undefined;

  @JsonProperty('ShowNonCheckedInUser', BooleanConverter, true)
  ShowNonCheckedInUser: boolean = undefined;

  @JsonProperty('ResturantMenu', [String], true)
  ResturantMenu: string[] = undefined;

  @JsonProperty('ResturantImages', [String], true)
  ResturantImages: string[] = undefined;

  @JsonProperty('ResturantItemMenu', [], true)
  ResturantItemMenu: [] = undefined;

  @JsonProperty('Pdf', NullableString, true)
  Pdf: string = undefined;

  @JsonProperty('TaxCountryId', NullableString, true)
  TaxCountryId: string = undefined;

  @JsonProperty('DefaultTaxType', NullableString, true)
  DefaultTaxType: string = undefined;

  @JsonProperty('IsActive', BooleanConverter, true)
  IsActive: boolean = undefined;

  @JsonProperty('ResturantAvailability', [ResturantAvailability], true)
  ResturantAvailability: ResturantAvailability[] = undefined;

  @JsonProperty('AllowedOrderTypes', [String], true)
  AllowedOrderTypes: string[] = undefined;

  @JsonProperty('RestaurantAddress', NullableString, true)
  RestaurantAddress: string = undefined;
  
  @JsonProperty('RestaurantPhoneNumber', NullableString, true)
  RestaurantPhoneNumber: string = undefined;

  @JsonProperty('RestaurantEmail', NullableString, true)
  RestaurantEmail: string = undefined;

  @JsonProperty('IsBookable', BooleanConverter, true)
  IsBookable: boolean = undefined;

  @JsonProperty('AdditionalInformation', [AdditionalInformationModel], true)
  AdditionalInformation: [AdditionalInformationModel] = undefined;

  @JsonProperty('CommentStatus', NullableString, true)
  CommentStatus: string = undefined;

  @JsonProperty('ServiceStationMode', BooleanConverter, true)
  ServiceStationMode: boolean = undefined;

  @JsonProperty('InclusiveMode', BooleanConverter, true)
  InclusiveMode: boolean = undefined;

  @JsonProperty('InclusiveModeSettings', Any, true)
  InclusiveModeSettings: any = undefined;
}

@JsonObject('ResturantResponseArrayModel')
export class ResturantResponseArrayModel {
  @JsonProperty('ResturantLists', [ResturantResponse], false)
  ResturantLists: [ResturantResponse] = undefined;

  @JsonProperty('CountLists', IntConverter, true)
  CountLists: number = undefined;
}
